angular.module('offlineChecker')
    .filter('guestsFilter', guestsFilter);

function guestsFilter() {
    return function (reservations, guestNamesIndex, leadFirstNameIndex, leadLastNameIndex, searchFor) {
        if (!Array.isArray(reservations)) {
            return reservations;
        }
        if (reservations.length === 0) {
            return reservations;
        }
        if (typeof guestNamesIndex !== "number") {
            return reservations;
        }
        if (typeof leadFirstNameIndex !== "number") {
            return reservations;
        }
        if (typeof leadLastNameIndex !== "number") {
            return reservations;
        }

        if (guestNamesIndex >= reservations[0].length) {
            return reservations;
        }
        if (!(guestNamesIndex >= 0)) {
            return reservations;
        }
        guestNamesIndex -= (guestNamesIndex % 1); // fix for floats being passed in

        if (leadFirstNameIndex >= reservations[0].length) {
            return reservations;
        }
        if (!(leadFirstNameIndex >= 0)) {
            return reservations;
        }
        leadFirstNameIndex -= (leadFirstNameIndex % 1); // fix for floats being passed in

        if (leadLastNameIndex >= reservations[0].length) {
            return reservations;
        }
        if (!(leadLastNameIndex >= 0)) {
            return reservations;
        }
        leadLastNameIndex -= (leadLastNameIndex % 1); // fix for floats being passed in

        if (typeof searchFor === 'string') {
            var out = [];
            angular.forEach(reservations, function (reservation) {
                var searchAgainst = '';
                if (reservation[leadFirstNameIndex]) {
                    searchAgainst += reservation[leadFirstNameIndex];
                }
                searchAgainst = searchAgainst.trim();
                if (reservation[leadLastNameIndex]) {
                    searchAgainst += ' ' + reservation[leadLastNameIndex];
                }
                searchAgainst = searchAgainst.trim();
                if (reservation[guestNamesIndex]) {
                    searchAgainst += ' ' + reservation[guestNamesIndex];
                }
                searchAgainst = searchAgainst.trim();

                if (searchFor) {
                    if (searchAgainst !== null) {
                        if (searchAgainst.toString().toLowerCase().indexOf(searchFor.toLowerCase()) > -1) {
                            out.push(reservation);
                        }
                    }
                } else {
                    out.push(reservation);
                }
            });
            return out;
        } else {
            return reservations;
        }
    }
}